import apiCall from './apiCall';
import { ApiRequestDescriptor } from './apiRequest.types';

export const executeQuery = <T>({
  url,
  config,
}: ApiRequestDescriptor): Promise<T> => apiCall<T>(url, config);
